export default function complaintForm() {
  if ($('.wl-contact-form-image-upload-wrapper').length == 0)
    return;

  preventComplaintFormIfNoOrderNo();

  const langIsSwedish = $('html').attr('lang') == 'sv-SE';
  const formInfoModalHTML = '<div class="form-info-modal"><div class="form-info-modal-background"></div><div class="form-info-wrapper"><div class="form-info-header"><span class="form-info-modal-close-btn">+</span></div><div class="form-info-list"><ul></ul></div></div></div>';
  const headerText = langIsSwedish ? 'Ladda upp bilder' : 'Upload images';
  const listPoints = langIsSwedish ? [
    'Ta ett foto där skadan/felet framgår tydligt.',
    'Ta ett foto där hela produkten syns.',
    'Vid transportsskada, ta gärna ett foto på det skadade emballaget.',
    'Ta ett foto på emballaget och gärna med produktens etikett.',
    'Vissa produkter har även en id-märkning som vi kan komma att behöva ett foto på vid senare tillfälle.'
  ]
    : [
        'Take a picture that clearly shows the damage.',
        'Take a picture on the article as a whole.',
        'If the damage occured during transport, please take a picture of the damaged packaging.',
        'Take a picture of the packaging that also shows the product label.',
        'Some products have an id-label that we might need a picture of at a later stage.'
      ];

  $('.wl-contact-form-image-upload-wrapper > .wl-contact-form-label').append('<span class="form-info-btn">i</span>');
  $('.wl-contact-form').append(formInfoModalHTML);
  $('.form-info-header').append(headerText);

  listPoints.forEach(function(point) {
    $('.form-info-list ul').append('<li class="form-info-point"><span>&#x2022;</span>' + point + '</li>');
  });

  $('.form-info-btn').click(function() {
    $('.form-info-modal').addClass('showing');
    $('body').css('overflow', 'hidden');
    $('.header').css('z-index', '-1');
  });

  $('.form-info-modal-close-btn').click(function() {
    $('.form-info-modal').removeClass('showing');
    $('body').css('overflow', 'auto');
    $('.header').css('z-index', '');
  });
}

function preventComplaintFormIfNoOrderNo() {
  if (document.querySelector('input[name="ordernummer-fakturanummer"]'))
    document.querySelector('input[name="ordernummer-fakturanummer"]').minLength = 5;
}
